import React from 'react';
import _ from 'lodash';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, FormProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { FilterCollapse } from '../FilterCollapse';
import { CustomButton } from './styles';

interface FilterCollapseFormProps extends FormProps {
	isCollapseOpen?: boolean;
	onClearClick?: () => void;
	children: React.ReactNode;
	showSearchButton?: boolean;
	disableClearButton: boolean;
	onFilterClick?: (params: any) => void;
}

const { useForm } = Form;

export function FilterCollapseForm({
	layout,
	children,
	onClearClick,
	onFilterClick,
	disableClearButton,
	initialValues = {},
	isCollapseOpen = false,
	showSearchButton = true,
	...props
}: Readonly<FilterCollapseFormProps>) {
	const [form] = useForm();
	const history = useHistory();
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);

	Object.keys(initialValues).forEach((key) => {
		const value = initialValues[key];
		return form.setFieldValue(key, value);
	});

	function handleClear(): void {
		form.resetFields();
		history.push({
			search: 'cleared=true'
		});
	}

	function handleFilter(filterData: any): void {
		const mappedDataToRequest = mapFilterDataToRequest(filterData);
		updateURLParams(mappedDataToRequest);
		if (onFilterClick) {
			onFilterClick(mappedDataToRequest);
		}
	}

	function mapFilterDataToRequest(filterData: any): any {
		const initialValues: any = {
			...filterData
		};
		return initialValues;
	}

	function updateURLParams(params: any): void {
		for (const key in params) {
			searchParams.delete('cleared');
			searchParams.delete(key);
			if (Object.hasOwn(params, key)) {
				const param = params[key];
				if (param && !_.isArray(param)) {
					searchParams.set(key, param);
				} else if (_.isArray(param)) {
					searchParams.set(key, JSON.stringify([...param]));
				}
			}
		}

		history.push({
			search: searchParams.toString()
		});
	}

	return (
		<FilterCollapse isCollapseOpen={isCollapseOpen}>
			<Form form={form} onFinish={handleFilter} layout={layout ?? 'vertical'} {...props}>
				{children}
				<Row gutter={[8, 8]} style={{ paddingTop: '10px' }}>
					{showSearchButton && (
						<Col xs={24} sm={12} lg={4} xl={3} xxl={3}>
							<CustomButton
								type="primary"
								htmlType="submit"
								style={{ width: '100%' }}
								icon={<SearchOutlined />}
							>
								{I18n.get('Search')}
							</CustomButton>
						</Col>
					)}
					<Col xs={24} sm={12} lg={4} xl={3} xxl={3}>
						<CustomButton
							style={{ width: '100%' }}
							disabled={disableClearButton}
							onClick={onClearClick ?? handleClear}
						>
							{I18n.get('Clear')}
						</CustomButton>
					</Col>
				</Row>
			</Form>
		</FilterCollapse>
	);
}
